import lockerService from '@/api/locker'
import { LOCKER }  from '../types'
import strings from '@/strings'

export default {
  namespaced: true,
  state: {
    lockers: [],
    pattern: '',
  },
  getters: {
    lockers: (state) => {
      return state.lockers
    },
    pattern: (state) => {
      return state.pattern
    },
    patternLockersIsValid: (state) => {
      return state.pattern && state.pattern.length > 0 ? state.pattern.includes("#") : false
    }
  },
  mutations: {
    [LOCKER.UPDATE_LOCKER] (state, locker) {
      state.lockers.set(locker.id, locker)
    },
    [LOCKER.LOCKER_SET] (state, lockers) {
      state.lockers = lockers
    },
    [LOCKER.PATTERN_SET](state, pattern) {
      state.pattern = pattern
    }
  },
  actions: {
    updateLocker ({commit}, data) {
      commit(LOCKER.UPDATE_LOCKER, data)
    },
    async getAvailableLockers ({commit}) {
      let response = await lockerService.getAvailableLockers()
      commit(LOCKER.LOCKER_SET, response.data)
    },
    async insertLocker({commit}, locker ){
      let lockerToChange = {
        active: true,
        hasBookings: false,
        id: locker.feature.id_,
        locationId: locker.locationId,
        name: locker.nextLockerName,
        numberOfSpots: 1,
        state: strings.pinStatus.inserted,
        x: locker.coordinates[0],
        y: locker.coordinates[1],
        bookable: true
      }
      await commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateTextLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      locker.name ? lockerToChange.name = locker.name : lockerToChange.numberOfSpots = locker.numberOfSpots
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateActiveLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      lockerToChange.active = locker.active
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateBookableLockerStore ({commit, state}, locker) {
      let lockerToChange = state.lockers.get(locker.id)
      lockerToChange.bookable = locker.bookable
      if(lockerToChange.state !== strings.pinStatus.inserted) {
        lockerToChange.state = strings.pinStatus.updated
      }
      commit(LOCKER.UPDATE_LOCKER, lockerToChange)
    },
    updateCoordinatesLockerStore({commit, state}, locker) {
      let selectedDesk = state.lockers.get(locker.id)
      selectedDesk.state = selectedDesk.state === strings.pinStatus.inserted ? strings.pinStatus.inserted : strings.pinStatus.updated
      selectedDesk.x = locker.coordinates[0]
      selectedDesk.y = locker.coordinates[1]
      commit(LOCKER.UPDATE_LOCKER, selectedDesk)
    },
    updateDeskCount ({commit}, count) {
      commit(LOCKER.LOCKERS_COUNT_SET, count)
    },
    setPattern ({commit}, pattern){
      commit(LOCKER.PATTERN_SET, pattern)
    }
  }
}
